module.exports = __webpack_public_path__ + "img/daughter.be5030ca.webp";